import { RiMotorbikeFill, RiHeartPulseFill, FaCarSide } from "../icons";
const homeTabData = [
  {
    id: '1',
    title: "Car & Taxi",
    type: "car",
    icon: <FaCarSide />,
  },
  {
    id: '2',
    title: "Bike",
    type: "bike",
    icon: <RiMotorbikeFill />,
  },
  {
    id: '3',
    title: "Health",
    type: "health",
    icon: <RiHeartPulseFill />,
  },
];

export default homeTabData;